import React, { Component }from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import { SkyLightStateless } from 'react-skylight';
import ReactDataGrid from 'react-data-grid';
import { Draggable, Data } from 'react-data-grid-addons';
import { UI_HEIGHT } from '../Common/constants';
import { Grid, Row, Col, Panel, Button, ButtonToolbar, Table, Breadcrumb } from 'react-bootstrap';
import { Link } from 'react-router';
import Spinner from '../../components/Widgets/spinner';
import CategoryForm from '../../containers/Products/categoryForm';
import checkPermission from '../Common/permissions';
//import {buttonStyle} from '../Common/style'
import CategoryInfoModal from './components/categoryInfoModal';
import ImageFormatter from '../Common/ImageFormatter';
import { isVAK, isSH, isAP, isCT, isUSPrideMulti } from '../../actions/root_url';

import { Translate, Localize } from 'react-redux-i18n';

const { Container: DraggableContainer, RowActionsCell, DropTargetRowContainer } = Draggable;
const { Selectors } = Data;
const RowRenderer = DropTargetRowContainer(ReactDataGrid.Row);
const styles = {
    modal: {
        height: '250px',
    },
}
class Categories extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            tableHeight: window.innerHeight-UI_HEIGHT.twoLineButton,

            rows: [],
            selectedRows: null,
            editedRows: [],
            filters: {},
            sortColumn: null,
            sortDirection: null,
            gourpOpen: false,
            categorieInfoModalVisibility: false,
            vakSkuError: false,
        };

        this.handleResize = this.handleResize.bind(this);
        this.openCategory = this.openCategory.bind(this);
        this.closeCategory = this.closeCategory.bind(this);
        this.onDrop = this.onDrop.bind(this);
        this.renderImage = this.renderImage.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        // this.props.fetchCategories();
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
        this.props.clearDeleteCategoryStatus();
    }

    // Once categories is ready, reset state.

    componentWillReceiveProps(nextProps) {
        const PT = nextProps.categories;
        if (nextProps.categories && nextProps.categories != this.props.categories) {
            let categories = nextProps.categories;
            let index = 0;
            categories.map(category => {
              category.Idx = index++;
              category.Index = category.Idx;
            })
            this.setState({
                rows: categories,
                selectedRows: null,
                editedRows: [],
            });
        }
        if(nextProps.multiEdited && nextProps.multiEdited != this.props.multiEdited) {
          this.props.fetchGroupCategories(this.props.currentGroup);
          this.setState({selectedRows: null, editedRows: []})
        }
        if(nextProps.deleteCategorySuccess && nextProps.deleteCategorySuccess != this.props.deleteCategorySuccess) {
          this.props.fetchGroupCategories(this.props.currentGroup);
          this.setState({selectedRows: null, editedRows: []})
        }
    }

    handleResize(e) {
        this.setState({tableHeight: window.innerHeight-UI_HEIGHT.twoLineButton});
    }

    updateRows(e) {
      const computedRows = this.state.rows.map((row) => {
      const editedRow = this.state.editedRows.find(({ ProductCategory_id }) => ProductCategory_id === row.ProductCategory_id);
        if (editedRow !== undefined) {
          return editedRow;
        }
          return row;
      });
      e.preventDefault();
      if (isVAK) {
        const result = computedRows.every(row => this.checkVakGroupSkuNum(row.CategoryNum2));
        if (!result) {
          this.setState({
            vakSkuError: true,
          });
          return false;
        } else {
          this.setState({
            vakSkuError: false,
          });
        }
      }
      this.props.editMultiCategories(computedRows);
    }

    deleteCategory(e) {
      e.preventDefault();
      let productCategory_id = this.state.selectedRows[0].ProductCategory_id;
      if(productCategory_id) {
        this.props.deleteCategory(productCategory_id);
      }
      else {
        let rows = [...this.state.rows];
        let editedRows = [...this.state.editedRows];
        let index = _.findIndex(rows, {Idx: this.state.selectedRows[0].Idx})
        rows.splice(index, 1);
        index = _.findIndex(editedRows, {Idx: this.state.selectedRows[0].Idx})
        editedRows.splice(index, 1);
        this.setState({rows, editedRows, selectedRows: []})
      }
    }

    openCategory() { this.setState({ gourpOpen: true }); }
    closeCategory() {
      this.props.fetchCategories();
      this.setState({ gourpOpen: false });
    }

    // Helper function to render an icon for the stock statues of product.


    renderIsEnabled(IsEnabled) {
        if (IsEnabled) return <span className="label label-success"><Translate value="enabled" /></span>;
        else return <span className="label label-danger"><Translate value="disabled" /></span>;
    }

    // Set categories being selected to be currentCategory and navigate user to the edit page

    setCurrentCategory(e) {
        e.preventDefault();
        const currentCategory = this.state.selectedRows[0];
        this.props.selectCategory(currentCategory);
        this.openCategory();
    }

    clickNew(e) {
        e.preventDefault();
        // this.props.resetCurrentCategory();
        // this.openCategory();
        let rows = Selectors.getRows(this.state);
        let index = rows.length;
        let newRow = {Name: null, Description: null, IsEnabled: false, Idx: index, ProductGroup_id: this.props.currentGroup};
        if (isVAK) {
          newRow.CategoryNum2 = null;
        }
        rows.push(newRow);
        let editedRows = [...this.state.editedRows];
        editedRows.push(newRow)
        this.setState({rows, editedRows})
    }

    renderImage(index) {
      let imageFile = '/img/dummy.png';
      if (index || index === 0) {
        imageFile = (this.state.rows[index].Image_Category || '/img/dummy.png');
      }
      return (
        <div className="group-img-view">
          <img
            src={imageFile}
            alt="Upload"
          />
        </div>
      );
    }
    checkVakGroupSkuNum = num => {
      if (!num) {
        return false;
      }
      if (!num.match(/^\d{2}-\d{2}$/)) {
        return false;
      }
      const nums = num.split('-');
      if (+nums[0] > +nums[1]) {
        return false;
      }
      return true;
    }

    onDrop(row, files) {
    if (!files) {
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      const index = row.props.rowIdx;
      const newRows = [...this.state.rows];
      const editedRows = [...this.state.editedRows];
      newRows[index].Image = reader.result;
      const editedRowIndex = _.findIndex(editedRows, r => r.Index === row.props.dependentValues.Index);
      if (editedRowIndex === -1) {
        editedRows.push(newRows[index]);
      } else {
        editedRows.splice(editedRowIndex, 1);
        editedRows.push(newRows[index]);
      }
      this.setState({ rows: newRows, editedRows });
    };
    // get the first file and convert to blob object (Blob.slice([start [, end [, contentType]]))
    const blob = files[0].slice(0, files[0].size, files[0].type);
    reader.readAsDataURL(blob);
  }

  onDrop(row, files) {
    if (!files) {
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      const index = row.props.rowIdx;
      const newRows = [...this.state.rows];
      const editedRows = [...this.state.editedRows];
      newRows[index].Image_Category = reader.result;
      const editedRowIndex = _.findIndex(editedRows, r => r.Index === row.props.dependentValues.Index);
      if (editedRowIndex === -1) {
        editedRows.push(newRows[index]);
      } else {
        editedRows.splice(editedRowIndex, 1);
        editedRows.push(newRows[index]);
      }
      this.setState({ rows: newRows, editedRows });
    };
    // get the first file and convert to blob object (Blob.slice([start [, end [, contentType]]))
    const blob = files[0].slice(0, files[0].size, files[0].type);
    reader.readAsDataURL(blob);
  }

    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

    renderTable() {
        if (this.props.categoryIsLoading && !this.props.categoryError) return <Spinner/>
        else if (this.props.categoryError) return <ContentWrapper><div className="alert alert-danger">{this.props.categoryError.message}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Selectors.getRows(this.state);
            }

            const getSize = () => {
                return getRows().length;
            }

            const isDraggedRowSelected = (selectedRows, rowDragSource) => {
              if (selectedRows && selectedRows.length > 0) {
                const key = this.props.rowKey;
                return selectedRows.filter(r => r[key] === rowDragSource.data[key]).length > 0;
              }
              return false;
            };

            const reorderRows = (e) => {
              const selectedRows = Selectors.getSelectedRowsByKey({ rowKey: this.props.rowKey, selectedKeys: [], rows: this.state.rows });
              const draggedRows = isDraggedRowSelected(selectedRows, e.rowSource) ? selectedRows : [e.rowSource.data];
              const undraggedRows = this.state.rows.filter(r => draggedRows.indexOf(r) === -1);
              const args = [e.rowTarget.idx, 0].concat(draggedRows);
              Array.prototype.splice.apply(undraggedRows, args);
              undraggedRows.map((row, index) => {
                row.Index = index;
              });
              this.setState({ rows: undraggedRows });
            };


            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
                this.setState(state);
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                this.setState({ filters: newFilters });
            }

            // Handle the editable function

            const handleRowUpdated = e => {
                // merge updated row with current row and rerender by setting state
                this.setState({sortColumn: null, sortDirection: null})
                let rows = getRows();
                let editedRows = this.state.editedRows.slice(0);
                if (isVAK) {
                  if (e.cellKey === 'CategoryNum2') {
                    const skuNum = e.updated[e.cellKey];
                    if (!this.checkVakGroupSkuNum(skuNum)) {
                      this.setState({
                        vakSkuError: true,
                      })
                      return false;
                    } else {
                      this.setState({
                        vakSkuError: false,
                      })
                    }
                  }
                }
                Object.assign(rows[e.rowIdx], e.updated);
                // if the element is already edited, remove the old one.
                editedRows.forEach((element, index) => {
                    if (element.Idx === rows[e.rowIdx].Idx)
                        editedRows.splice(index, 1)
                }, this);
                // push the row into the editedRows array
                editedRows.push(rows[e.rowIdx]);
                this.setState({
                    rows: rows,
                    editedRows: editedRows
                });
            }

            // Handle the Dragable cell function

            const handleCellDrag = e => {
                let rows = this.state.rows.slice(0);
                let editedRows = this.state.editedRows.slice(0);
                for (let i = e.fromRow; i <= e.toRow; i++) {
                    let rowToUpdate = rows[i];
                    rowToUpdate[e.cellKey] = e.value;
                    // if the element is already edited, remove the old one.
                    editedRows.forEach((element, index) => {
                        if (element.ProductCategory_id === rowToUpdate.ProductCategory_id)
                            editedRows.splice(index, 1)
                    }, this);
                    // push the row into the editedRows array
                    editedRows.push(rowToUpdate);
                }
                this.setState({
                    rows: rows,
                    editedRows: editedRows
                });
            }

            const handleDragHandleDoubleClick = e => {
                var rows = this.state.rows.map(function (r) {
                    return Object.assign({}, r);
                });
                let editedRows = this.state.editedRows.slice(0);
                var column = columns[e.idx - 1];
                for (var i = e.rowIdx; i <= rows.length - 1; i++) {
                    var rowToUpdate = rows[i];
                    rowToUpdate[column.key] = e.rowData[column.key];
                    // if the element is already edited, remove the old one.
                    editedRows.forEach((element, index) => {
                        if (element.ProductCategory_id === rowToUpdate.ProductCategory_id)
                            editedRows.splice(index, 1)
                    }, this);
                    // push the row into the editedRows array
                    editedRows.push(rowToUpdate);
                }
                this.setState({ rows: rows });
            }

            //Custom Formatter component
            const IsEnabledFormatter = React.createClass({
                render() {
                  return (
                    <input type="checkbox" value="true" checked={this.props.value == true || this.props.value == "true"} onClick={()=>{handleIsEnabledClick(this.props)}}/>
                  )
                }
            });

            const handleIsEnabledClick = (isEnabled) => {
              let rows = getRows();
              let index = _.findIndex(rows, {Idx: isEnabled.dependentValues.Idx})
              rows[index].IsEnabled = !(rows[index].IsEnabled);
              let editedRows = [...this.state.editedRows];
              editedRows.map((row, idx) => {
                  if (row.Idx === rows[index].Idx)
                      editedRows.splice(idx, 1)
              });
              editedRows.push(rows[index])
              this.setState({rows, editedRows});
            }

            // Handle the row select function

            // const onRowSelect = rows => {
            //     this.setState({ selectedRows: rows });
            // }

            const onRowsSelected = (rows) => {
                 let newRows = getRows();
                 newRows.map(r => {
                   r.isSelected = false;
                 })
                 rows.map (r => {
                   newRows[r.rowIdx].isSelected = true;
                 });
                 this.setState({ rows: newRows, selectedRows: [rows[0].row] });
            }

             const onRowsDeselected = (rows) => {
                 let newRows = getRows();
                 rows.map (r => {
                   newRows[r.rowIdx].isSelected = false;
                 });
                 this.setState({rows: newRows, selectedRows: []});
             }

            // Column difinition

            const columns = [
              {
                key: 'CategoryNum',
                name: <Translate value="id" />,
                resizable: true,
                sortable: true,
                editable: true,
                filterable: true,
                width: 100,
            },
              {
                  key: 'Name',
                  name: <Translate value="name" />,
                  resizable: true,
                  sortable: true,
                  editable: true,
                  filterable: true,
                  width: 200,
              },
              {
                  key: 'Description',
                  name: <Translate value="description" />,
                  resizable: true,
                  sortable: true,
                  editable: true,
                  filterable: true,
                  width: 160,
              },
              ...(isSH || isAP) ? [{
                key: 'MinQuantity',
                name: <Translate value="min_qty"/>,
                resizable: true,
                sortable: true,
                editable: true,
                filterable: true,
                width: 100,
              }] : [],
              ...(isSH || isAP) ? [{
                key: 'MaxQuantity',
                name: <Translate value="max_qty"/>,
                resizable: true,
                sortable: true,
                editable: true,
                filterable: true,
                width: 100,
              }] : [],
              ...isVAK ? [{
                key: 'CategoryNum2',
                name: <Translate value="sku_num"/>,
                resizable: true,
                sortable: true,
                editable: true,
                filterable: true,
                width: 160,
              }] : [],
              {
                  key: 'IsEnabled',
                  name: <Translate value="enabled" />,
                  resizable: true,
                  sortable: true,
                  // filterable: true,
                  formatter: IsEnabledFormatter,
                  getRowMetaData: (row) => row,
                  width: 80,
              }
            ];

            if (isCT) {
              const imageColumn = {
                key: 'Image_Category',
                name: <Translate value="image" />,
                resizable: true,
                sortable: false,
                editable: false,
                filterable: false,
                width: 220,
                formatter: (
                  <ImageFormatter
                    renderImage={this.renderImage}
                    onDrop={this.onDrop}
                    showImageOnly
                  />
                ),
                getRowMetaData: row => row,
              }
              columns.splice(0, 0, imageColumn);
            }

            if (isUSPrideMulti) {
              const PackShowParentCol = {
                key: 'PackShowParent',
                name: <Translate value="pack_show_parent" />,
                resizable: true,
                // sortable: true,
                // filterable: true,
                formatter: <PackShowParentFormatter />,
                getRowMetaData: (row) => row,
                width: 80,
              };
              const enableIdx = _.findIndex(columns, { key: "IsEnabled"});
              columns.splice(enableIdx, 0, PackShowParentCol);
            }

            const rowHeight = isCT ? 120 : 25;

            return (
                <Row><Col sm={ 12 }><div style={{ maxWidth: '99%' }} id="Categories-dataGrid1">
                  <DraggableContainer>
                    <ReactDataGrid
                        enableCellSelect={true}
                        onGridSort={handleGridSort}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        minHeight={620}
                        rowHeight={rowHeight}
                        headerRowHeight={25}
                        enableRowSelect='single'
                        onDragHandleDoubleClick={handleDragHandleDoubleClick}
                        onCellsDragged={handleCellDrag}
                        onRowUpdated={handleRowUpdated}
                        // onRowSelect={onRowSelect}
                        rowSelection={{
                          showCheckbox: true,
                          onRowsSelected: onRowsSelected,
                          onRowsDeselected: onRowsDeselected,
                          selectBy: {
                            isSelectedKey: 'isSelected'
                          }
                        }}
                        rowRenderer={<RowRenderer onRowDrop={reorderRows} />}
                        rowActionsCell={RowActionsCell}
                    />
                  </DraggableContainer>
                </div></Col></Row>
            )
        }
    }

    formTitle() {
        if (this.props.currentCategory) return "Edit Category";
        else return <Translate value="add_a_new_category" />;
    }

    handleEditButtonClick = (event) => {
        event.preventDefault();
        this.setCategorieInfoModalVisibility(true);
    }

    setCategorieInfoModalVisibility = (isVisible) => {
        this.setState({
            categorieInfoModalVisibility: isVisible
        })
    }

    handleCategoryInfoEditConfirm = (category) => {
        const newCategories = [...this.state.rows];
        newCategories[category.Idx] = category;
        this.setState({
            rows: newCategories,
        }, () => {
            this.setCategorieInfoModalVisibility(false);
        });
    }

    render() {
      const createDialogStyle = {
        width: '950px',
        height: '500px',
        marginLeft: '-15%',
      };
        const categoryInfoTitle = (<Translate value="category_info_edit" />);
        return (
          //---------------
          // Begin HTML: Create New/Edit product_categories
          //---------------
            <ContentWrapper>
              {/* <Breadcrumb>
                <Breadcrumb.Item>
                  <Translate value="general_management" />
                </Breadcrumb.Item>
                <Breadcrumb.Item active="true">
                  <Translate value="product_categories" />
                </Breadcrumb.Item>
              </Breadcrumb> */}
                {/* <div className="content-heading"><Translate value="product_categories" /></div> */}
                  <ButtonToolbar className="group-management-table-buttons">
                    <Button
                        bsStyle="primary"
                        className="marginLeftStyle"
                        onClick={(event) => { this.clickNew(event) } }
                        disabled={!checkPermission("add_product_category")}
                    >
                        <em className="fa fa-plus marginRightStyle"/><Translate value="create" />
                    </Button>
                    <Button
                        bsStyle="success"
                        className="buttonStyle"
                        onClick={(event) => { this.updateRows(event) } }
                        disabled={!this.state.editedRows || !checkPermission("change_product_category")}>
                        <em className="fa fa-save marginRightStyle" /><Translate value="save" />
                    </Button>
                    <Button
                        bsStyle="success"
                        className="buttonStyle"
                        onClick={(event) => { this.handleEditButtonClick(event) } }
                        disabled={!this.state.selectedRows || this.state.selectedRows.length != 1 || !checkPermission("delete_product_category")}
                    >
                        <em className="fa fa-save marginRightStyle" /><Translate value="edit" />
                    </Button>
                    <Button
                      bsStyle="danger"
                      className="buttonStyle"
                      onClick={(event) => { this.deleteCategory(event) }}
                      disabled={!this.state.selectedRows || this.state.selectedRows.length != 1 || !checkPermission("delete_product_category")}
                      ><em className="fa fa-trash marginRightStyle" /><Translate value="delete" />
                    </Button>
                  </ButtonToolbar>
                {this.renderTable() }
                {/* <SkyLightStateless isVisible={this.state.gourpOpen} onCloseClicked={() => { this.closeCategory() } } title={this.formTitle() }>
                    <CategoryForm closeC={this.closeCategory} />
                </SkyLightStateless> */}
                <br/>
                  {
                    this.props.multiIsEditing &&
                    <div className="alert alert-info categories-saving-info"><span className=""><Translate value="saving" /></span></div>
                  }
                  {
                    this.props.multiEdited &&
                    <div className="alert alert-success categories-saving-info">
                      <span className=""><Translate value="saved" /></span>
                    </div>
                  }
                  {
                    this.props.deletingCategory &&
                    <div className="alert alert-info categories-saving-info"><span className=""><Translate value="deleting" /></span></div>
                  }
                  {
                    this.props.deleteCategorySuccess &&
                    <div className="alert alert-success categories-saving-info">
                      <span className=""><Translate value="deleted" /></span>
                    </div>
                  }
                  {
                    this.props.deleteCategoryError &&
                    <div className="alert alert-danger categories-saving-info">
                      <span className="">{this.props.deleteCategoryError}</span>
                    </div>
                  }
                  {
                      this.props.multiError &&
                      <div className="alert alert-danger categories-saving-info">
                        <span className=""><Translate value="Name_and_Description_fields_are_required"/></span>
                      </div>
                  }
              {
                this.state.vakSkuError &&
                <div className="alert alert-danger categories-saving-info">
                  <span className=""><Translate value="sku_num_format_error"/> EX: 01-01, 01-02</span>
                </div>
              }
              <SkyLightStateless title={categoryInfoTitle} dialogStyles={createDialogStyle} isVisible={this.state.categorieInfoModalVisibility} onCloseClicked={() => {
                this.setCategorieInfoModalVisibility(false) } }>
                    <CategoryInfoModal selectedRows={this.state.selectedRows} handleConfirmClick={this.handleCategoryInfoEditConfirm} />
                </SkyLightStateless>
            </ContentWrapper>
        );
    }
}



export default Categories;



// WEBPACK FOOTER //
// ./master/jsx/components/Products/categories.jsx